/**
 * Featured Webinar
 */
import { Component, registerComponent } from 'js/component.js';
import { hasDatePassed, formatIsoDateTime } from 'js/helpers.js';

const componentName = 'featured-webinar';

export class FeaturedWebinar extends Component {
    /** Component elements */
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        eventTimeItem: this.element.querySelector('.event-time'),
    };

    /** Initialize components */
    init() {
        if (this.elements.container != null) {
            const webinarOnDemand = this.elements.container.getAttribute('data-webinar-on-demand');
            const webinarType = this.elements.container.getAttribute('data-webinar-type');
            const webinarInstances = this.elements.container.getAttribute('data-webinar-instances');
            let dateLabel = null;
            let timeLabel = null;

            const tileDate = this.elements.container.querySelector('.date-details');
            if (tileDate) {
                const dateContent = tileDate.innerHTML;
                dateLabel = dateContent.substring(0, dateContent.indexOf('/span>') + 6);
            }

            const tileTime = this.elements.container.querySelector('.time-details');
            if (tileTime) {
                const timeContent = tileTime.innerHTML;
                timeLabel = timeContent.substring(0, timeContent.indexOf('/span>') + 6);
            }

            if (webinarInstances == null) {
                const eventStart = this.elements.eventTimeItem.getAttribute('data-start-time');

                const {
                    startDate, startTime, timeZoneLong, timeZoneShort
                } = formatIsoDateTime(eventStart);

                if (tileDate) {
                    tileDate.innerHTML = `${dateLabel} ${startDate}`;
                }
                if (tileTime) {
                    tileTime.innerHTML = `${timeLabel} ${startTime} <span class="info" title="${timeZoneLong}">${timeZoneShort}</span>`;
                }

            } else {
                const instanceArrayAll = webinarInstances.split(',');
                let instanceArrayFuture = [];
                for (let i = 0; i < instanceArrayAll.length; i += 1) {
                    const instanceDateTime = instanceArrayAll[i].substring(0, instanceArrayAll[i].indexOf('--'));
                    if (!hasDatePassed(instanceDateTime)) {
                        instanceArrayFuture = instanceArrayAll.slice(i);
                        break;
                    }
                }

                let instanceToDisplay = instanceArrayAll[instanceArrayAll.length - 1].split('--'); // Default to last instance
                if (instanceArrayFuture.length !== 0) {
                    // Replace initial webinar details with next future instance
                    instanceToDisplay = instanceArrayFuture[0].split('--');
                }
                const {
                    startDate, startTime, timeZoneLong, timeZoneShort
                } = formatIsoDateTime(instanceToDisplay[0]);

                if (tileDate) {
                    tileDate.innerHTML = `${dateLabel} ${startDate}`;
                }
                if (tileTime) {
                    tileTime.innerHTML = `${timeLabel} ${startTime} <span class="info" title="${timeZoneLong}">${timeZoneShort}</span>`;
                }
            }

            let activeLabel;

            if (webinarType.toLowerCase() === 'series') {
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_series`);
            } else if (!hasDatePassed(webinarOnDemand)) {
                this.elements.container.setAttribute('data-webinar-type', 'future webinar');
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_future`);
            } else {
                this.elements.container.setAttribute('data-webinar-type', 'past webinar');
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_past`);
            }
            activeLabel.classList.add('active');
        }
    }
}

registerComponent(`.${componentName}`, FeaturedWebinar);
